import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import ExerciseCategoriesPage from "./ExerciseCategoriesPage";
import ExerciseCategoryCreatePage from "./ExerciseCategoryCreatePage";
import ExerciseCategoryEditPage from "./ExerciseCategoryEditPage";
 

export default (
  <Route path="exercise-categories">
    <Route
      index
      element={
        <Protected
          path="/admin/app-files"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <ExerciseCategoriesPage />
        </Protected>
      }
    />

    <Route
      path="create"
      element={
        <Protected
          path="/admin/exercise-categories/create"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <ExerciseCategoryCreatePage />
        </Protected>
      }
    />
    
    <Route
      path="edit/:id"
      element={
        <Protected
          path="/admin/exercise-categories/edit/:id"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <ExerciseCategoryEditPage />
        </Protected>
      }
    /> 
  </Route>
);
